import Basic from "./Basic.jsx";

export default {
  Basic,
};
